import {
  DRIVER_VIEWPORT_MAXIMIZED_TOLERANCE_X_PX,
  DRIVER_VIEWPORT_NARROW_WIDTH_PX,
  DRIVER_VIEWPORT_ZOOM_COLLAPSE_RATIO,
} from "./viewportConstants";

/**
 * 窄屏：与主应用「浏览器宽度较小」提示同一阈值。
 */
export function isViewportNarrowForDriver(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth < DRIVER_VIEWPORT_NARROW_WIDTH_PX;
}

/**
 * 启发式：Ctrl/Cmd 浏览器缩放约 ≥130% 时，在接近最大化的窗口下，
 * screen.availWidth / innerWidth 会明显大于 1（visualViewport.scale 在桌面 Ctrl 缩放下通常为 1）。
 * 非最大化窗口不用此规则，避免小窗误伤。
 */
export function isLikelyBrowserZoomedInForCollapse(): boolean {
  if (typeof window === "undefined") return false;
  const sw = window.screen?.availWidth ?? 0;
  const iw = window.innerWidth;
  const ow = window.outerWidth;
  if (!sw || !iw) return false;
  const nearlyMaximized = ow >= sw - DRIVER_VIEWPORT_MAXIMIZED_TOLERANCE_X_PX;
  if (!nearlyMaximized) return false;
  const ratio = sw / iw;
  return ratio >= DRIVER_VIEWPORT_ZOOM_COLLAPSE_RATIO && ratio < 2.5;
}

export function shouldResponsiveCollapseSidebar(): boolean {
  return isViewportNarrowForDriver() || isLikelyBrowserZoomedInForCollapse();
}
